import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetUsersList = (currentPage, pageSize, searchValue, status, sortField, sortOrder) => {
  const data = useQuery(
    ["usersList", currentPage, pageSize, searchValue, status, sortField, sortOrder],
    () =>
      axiosClient.get(
        `/User/GetUserListService?currentPage=${currentPage}&pageSize=${pageSize}&searchValue=${searchValue}&status=${status}&sortField=${sortField}&sortOrder=${sortOrder}`
      )
  );

  return data;
};
export default useGetUsersList;
